/* Tyre Dispatch page template — light/dark toggle, mobile Shop/Quote bar, sticky guide menu, current-section tracking (v1.5)
   Include once as assets/td-theme-toggle.js (the td-guide section loads it).
   1. Any <button data-td-theme-toggle> inside a .td-page flips every .td-page on
      the page between light (default) and dark, and remembers the choice.
   2. The mobile Shop/Quote bar (.td-stickybar) stays off-screen until the reader
      has scrolled past the top of the guide, and slides away again near the
      page footer, so it never covers the hero or the CTA. */
(function () {
  var KEY = "td-theme";
  function apply(t) {
    var pages = document.querySelectorAll(".td-page");
    for (var i = 0; i < pages.length; i++) {
      if (t === "dark") pages[i].setAttribute("data-theme", "dark");
      else pages[i].removeAttribute("data-theme");
    }
  }
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved === "dark") apply("dark");
  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-td-theme-toggle]") : null;
    if (!b) return;
    var page = b.closest(".td-page");
    var next = page && page.getAttribute("data-theme") === "dark" ? "light" : "dark";
    apply(next);
    try { localStorage.setItem(KEY, next); } catch (e) {}
  });

  var page = document.querySelector(".td-page");
  if (!page) return;
  var html = document.documentElement;

  /* ---- 2. mobile sticky Shop/Quote bar: hidden at the top, visible once past the hero,
          hidden again once the CTA is on screen so it never sits on top of it ---- */
  var bar = page.querySelector(".td-stickybar");
  function updateBar() {
    if (!bar) return;
    var hero = page.querySelector(".td-hero") || page.querySelector(".td-takeaways");
    var pastHero = hero ? hero.getBoundingClientRect().bottom < 80 : true;
    var end = page.querySelector(".td-cta") || page.querySelector(".td-author");
    var nearEnd = end ? end.getBoundingClientRect().top < window.innerHeight : false;
    bar.classList.toggle("is-offscreen", !(pastHero && !nearEnd));
  }
  if (bar) bar.classList.add("is-offscreen");

  /* ---- 3. header height: prefer the value set by snippets/td-compact-header, else measure ---- */
  function headerH() {
    var v = parseFloat(getComputedStyle(html).getPropertyValue("--td-header-h"));
    if (!isNaN(v)) return v;
    var h = document.querySelector(".shopify-section-header");
    var b = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
    html.style.setProperty("--td-header-h", b + "px");
    return b;
  }

  /* ---- 4. sticky guide menu (phones/tablets): the article's "In this guide" details ---- */
  var narrow = window.matchMedia("(max-width: 1179px), (any-hover: none)");  /* matches the stylesheet: a phone in desktop mode reports a wide viewport but never hover */
  var mainToc = page.querySelector(".td-main > .td-toc") || page.querySelector(":scope > .td-toc");
  var summary = mainToc ? mainToc.querySelector("summary") : null;
  function setupToc() {
    if (!mainToc) return;
    if (narrow.matches) {
      mainToc.removeAttribute("open");
      if (summary && !summary.getAttribute("data-now")) summary.setAttribute("data-now", "Sections");
    } else {
      mainToc.setAttribute("open", "");
    }
  }
  setupToc();
  if (narrow.addEventListener) narrow.addEventListener("change", setupToc); else if (narrow.addListener) narrow.addListener(setupToc);
  document.addEventListener("click", function (e) {
    if (!mainToc || !narrow.matches || !e.target.closest) return;
    var link = e.target.closest(".td-toc__body a");
    if (link && mainToc.contains(link)) { mainToc.removeAttribute("open"); return; }   /* tap a section: jump + close */
    if (mainToc.hasAttribute("open") && !mainToc.contains(e.target)) mainToc.removeAttribute("open"); /* tap outside: close */
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && mainToc) mainToc.removeAttribute("open"); });

  /* ---- 5. current-section tracking: highlights the TOC link (rail + guide menu) and labels the bar ---- */
  var links = [].slice.call(page.querySelectorAll(".td-toc__body a[href^='#']"));
  var targets = [];
  links.forEach(function (a) {
    var el = document.getElementById(a.getAttribute("href").slice(1));
    if (el && targets.indexOf(el) < 0) targets.push(el);
  });
  var lastId = null;
  function track() {
    if (!targets.length) return;
    var line = headerH() + 90;
    var cur = null;
    for (var i = 0; i < targets.length; i++) { if (targets[i].getBoundingClientRect().top <= line) cur = targets[i]; }
    var id = cur ? cur.id : null;
    if (id === lastId) return;
    lastId = id;
    links.forEach(function (a) { a.classList.toggle("is-current", !!id && a.getAttribute("href") === "#" + id); });
    if (summary) {
      var label = "Sections";
      if (id) {
        var a = mainToc.querySelector(".td-toc__body a[href='#" + id + "']");
        var h = a && (a.querySelector(".td-toc__h") || a);
        if (h) label = h.textContent.replace(/\s+/g, " ").trim();
      }
      summary.setAttribute("data-now", label);
    }
  }

  var ticking = false;
  function update() { ticking = false; updateBar(); track(); }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("scroll", onScroll, { passive: true, capture: true }); /* themes that scroll a container */
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", update);
  update();
})();
